/**
 * The SPA session as a writer (PLAN §6.1): `@norna/api-client/writer.js`'s writer, one per editor session (`web-…` node
 * ids and clientOpIds) — see there for why one per session keeps two tabs' HLCs apart (D6). Causality: every row the
 * session receives is `observe`d, so a local edit is always newer than what the user was looking at when they made
 * it — the "latest wins" of PLAN §6.2 means the latest the user saw, not the latest wall clock.
 */
import { createWriter, type Writer } from '@norna/api-client/writer.js';

export function createSessionWriter(nowMs: () => number, randomBytes: (count: number) => Uint8Array): Writer {
  return createWriter({ node: 'web', op: 'web' }, nowMs, randomBytes);
}
